import { createAPI } from '@common'

export default {
  // 读频道列表 - new
  getMamTvChannelsList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0f60mjtuebub', 'post', config),
  // 读一个频道 - new
  getMamTvChannels: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0uw0diboofm', 'get', config),
  // 新建频道 - new
  postMamTvChannels: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0uw0diboofm', 'post', config),
  // 修改频道 - new
  putMamTvChannels: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0uw0diboofm0vqebuf', 'post', config),
  // 频道预览
  getMamTvChannelsPreview: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0uw0diboofmt0qsfwjfx', 'get', config),
  // 删除频道
  deleteMamTvChannels: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0uw0diboofm', 'delete', config),
  // 新建节目
  postMamTvPrograms: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0uw0qsphsbn', 'post', config),
  // 修改节目
  putMamTvPrograms: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0uw0qsphsbn0vqebuf', 'post', config),
  // 删除节目
  postMamTvProgramsDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0uw0qsphsbn', 'delete', config),
  // 复制节目单
  postMamTvProgramsCopy: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0uw0qsphsbn0dpqz', 'post', config),
  // 按周复制节目单
  postMamTvProgramsCopyRange: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0uw0qsphsbn0dpqzSbohf', 'post', config),
  // 节目详情,
  getMamTvPrograms: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0uw0qsphsbn', 'get', config),
  // 修改节目单回放url
  postMamTvProgramsUpdateUrl: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0uw0qsphsbn0vqebufVsm', 'post', config),
  // 获取渠道操作的权限
  getMamTvOperates: (config) => createAPI('customEncryptApiName-1/0w20nbn0uw0pqfsbuft', 'get', config),
  // 获取视频的具体信息
  getMamVideoDetailHideMessage: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0wjefp0efubjm', 'get', config, {
      isHideErrorMessage: true
    }),
  // 音频详情
  getMamAudioDetailHideMessage: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0bvejp0efubjm', 'GET', config, {
      isHideErrorMessage: true
    }),
  // 下载节目单模板
  getTvProgramTemplate: (config, otherConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0uw0qsphsbn0ufnqmbuf',
      'get',
      config,
      otherConfig
    ),
  // 导入节目单
  postMamTvProgramsImport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0uw0qsphsbn0jnqpsu', 'post', config),
  // 获取节目单收录推流地址
  getMamTvPushUrl: () =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0uw0qsphsbn0hfuQvtiVsm', 'get'),
  // 运营管理页面展示页签设置
  getConfigTvChannels: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0uw0diboofm0hfuDpogjh', 'get', config),
  // 运营管理页面修改页签设置
  setConfigTvChannels: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0uw0diboofm0tfuDpogjh', 'post', config),
  // 获取时移播放链接
  getStripUrl: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0tusjq0uw0hfuVsm', 'post', config),
  // 导出视频
  exportStrip: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0tusjq0fyqpsu', 'post', config),
  // 获取已授权流量、导播时长
  getAuthLiveExpense: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfFyqfotf0hfuBvui', 'get', config)
}
